interface ResolveDateModifiedArgs {
  override?: unknown;
  updatedAt?: unknown;
  datePublished?: unknown;
}

const asDateString = (value: unknown): string => (typeof value === 'string' ? value : '');

const timestamp = (value: string): number | null => {
  if (!value) {
    return null;
  }

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
};

const resolveDateModified = ({ override, updatedAt, datePublished }: ResolveDateModifiedArgs): string => {
  const published = asDateString(datePublished);
  const candidate = [override, updatedAt].map(asDateString).find((value) => timestamp(value) !== null) ?? published;

  const candidateAt = timestamp(candidate);
  const publishedAt = timestamp(published);

  if (candidateAt !== null && publishedAt !== null && candidateAt < publishedAt) {
    return published;
  }

  return candidate;
};

export default resolveDateModified;
